import Loading from '@components/loading/Loading'
import type { NextPage } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import Head from 'next/head'
import { useRouter } from 'next/router'
import SwapPage from '@components/swap/SwapPage'
import { withCommonNamespaces } from 'utils/common-namespaces'
import { useTranslation } from 'next-i18next'

const metaTitle = "Solana's next-gen spot trading DEX | Cabana"

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await serverSideTranslations(
        locale,
        withCommonNamespaces(['chart', 'index', 'orderbook', 'swap', 'trade']),
      )),
      metaTitle,
    },
  }
}

const Index: NextPage = () => {
  const router = useRouter()
  const { t } = useTranslation('index')

  if (router?.isFallback) {
    return (
      <div className="flex h-[calc(100vh-368px)] flex-col items-center justify-center">
        <Loading />
      </div>
    )
  }
  return (
    <>
      <Head>
        <title>{t('title')}</title>
      </Head>
      <SwapPage />
    </>
  )
}

export default Index
